import { amplifyConfig } from "@/config/amplify";

export interface AccessControlUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  tenantId: string;
  sicId: string;
  permissions: string[];
  roles: string[];
}

/**
 * Fetch current user information from access-control API
 */
export async function getCurrentUserInfo(accessToken: string): Promise<AccessControlUser | null> {
  try {
    const response = await fetch(`${amplifyConfig.accessControlApiUrl}/user`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch user info: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    // Log error for debugging
    // eslint-disable-next-line no-console
    console.error("Error fetching user info from access-control API:", error);
    return null;
  }
}
